import * as products from 'app/mocks/data/catalogue/products/list'
import * as managers from 'app/mocks/data/park/managers/list'
import * as sites from 'app/mocks/data/park/sites/list'
import * as konvives from 'app/mocks/data/users/konvives/list'

import { newDateFormatted } from 'app/utils/date'

import { Order, StatusOrder } from 'app/types/operations/order'

export const order401: Order = {
    id: 401,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive1,
    site: sites.site1,
    price: 4,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: true,
            quantity: 100,
        },
        {
            product: products.product2,
            is_weight_quantity: true,
            quantity: 500,
        },
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-20)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: true,
                    quantity: 500,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-20)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager8,
            changes: [],
        },
    ],
}

export const order402: Order = {
    id: 402,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive2,
    site: sites.site1,
    price: 4,
    articles: [
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-19)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-19)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-19)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order403: Order = {
    id: 403,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0611223344',
    site: sites.site2,
    price: 4,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 300,
        },
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-18)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0611223344',
            changes: [
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 300,
                },
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager3,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-18)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager3,
            changes: [],
        },
    ],
}

export const order404: Order = {
    id: 404,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive3,
    site: sites.site3,
    price: 4,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-17)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-17)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-17)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order405: Order = {
    id: 405,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0622334455',
    site: sites.site4,
    price: 4,
    articles: [
        {
            product: products.product9,
            is_weight_quantity: true,
            quantity: 450,
        },
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-16)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0622334455',
            changes: [
                {
                    product: products.product9,
                    is_weight_quantity: true,
                    quantity: 450,
                },
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager5,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-16)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager5,
            changes: [],
        },
    ],
}

export const order406: Order = {
    id: 406,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive4,
    site: sites.site5,
    price: 4,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: true,
            quantity: 200,
        },
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 35,
        },
        {
            product: products.product13,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-15)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-15)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [
                {
                    product: products.product11,
                    is_weight_quantity: true,
                    quantity: 200,
                },
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 35,
                },
                {
                    product: products.product13,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-15)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order407: Order = {
    id: 407,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0633445566',
    site: sites.site6,
    price: 4,
    articles: [
        {
            product: products.product14,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-14)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive2,
            changes: [
                {
                    product: products.product14,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager2,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-14)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager2,
            changes: [],
        },
    ],
}

export const order408: Order = {
    id: 408,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive5,
    site: sites.site7,
    price: 4,
    articles: [
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 2,
        },
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 1,
        },
        {
            product: products.product17,
            is_weight_quantity: true,
            quantity: 425,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive5,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 2,
                },
                {
                    product: products.product16,
                    is_weight_quantity: false,
                    quantity: 1,
                },
                {
                    product: products.product17,
                    is_weight_quantity: true,
                    quantity: 425,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order409: Order = {
    id: 409,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0644556677',
    site: sites.site8,
    price: 4,
    articles: [
        {
            product: products.product18,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product19,
            is_weight_quantity: true,
            quantity: 150,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0644556677',
            changes: [
                {
                    product: products.product18,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product19,
                    is_weight_quantity: true,
                    quantity: 150,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager1,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager1,
            changes: [],
        },
    ],
}

export const order410: Order = {
    id: 410,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive6,
    site: sites.site9,
    price: 4,
    articles: [
        {
            product: products.product20,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-13)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive6,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-13)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [
                {
                    product: products.product20,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-13)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order411: Order = {
    id: 411,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0655667788',
    site: sites.site10,
    price: 4,
    articles: [
        {
            product: products.product21,
            is_weight_quantity: false,
            quantity: 5,
        },
        {
            product: products.product22,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-12)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0655667788',
            changes: [
                {
                    product: products.product21,
                    is_weight_quantity: false,
                    quantity: 5,
                },
                {
                    product: products.product22,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager7,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-12)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager7,
            changes: [],
        },
    ],
}

export const order412: Order = {
    id: 412,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive7,
    site: sites.site11,
    price: 4,
    articles: [
        {
            product: products.product23,
            is_weight_quantity: false,
            quantity: 32,
        },
        {
            product: products.product24,
            is_weight_quantity: false,
            quantity: 17,
        },
        {
            product: products.product1,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-11)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive7,
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-11)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [
                {
                    product: products.product23,
                    is_weight_quantity: false,
                    quantity: 32,
                },
                {
                    product: products.product24,
                    is_weight_quantity: false,
                    quantity: 17,
                },
                {
                    product: products.product1,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-11)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order413: Order = {
    id: 413,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0666778899',
    site: sites.site12,
    price: 4,
    articles: [
        {
            product: products.product2,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-10)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0666778899',
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager6,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-10)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager6,
            changes: [
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-10)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager6,
            changes: [],
        },
    ],
}

export const order414: Order = {
    id: 414,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive8,
    site: sites.site13,
    price: 4,
    articles: [
        {
            product: products.product3,
            is_weight_quantity: false,
            quantity: 600,
        },
        {
            product: products.product4,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-9)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive8,
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 600,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-9)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order415: Order = {
    id: 415,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0677889900',
    site: sites.site14,
    price: 4,
    articles: [
        {
            product: products.product5,
            is_weight_quantity: true,
            quantity: 225,
        },
        {
            product: products.product6,
            is_weight_quantity: false,
            quantity: 3,
        },
        {
            product: products.product7,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-8)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0677889900',
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager4,
            changes: [
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 225,
                },
                {
                    product: products.product6,
                    is_weight_quantity: false,
                    quantity: 3,
                },
                {
                    product: products.product7,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-8)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager4,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-8)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager4,
            changes: [],
        },
    ],
}

export const order416: Order = {
    id: 416,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive9,
    site: sites.site15,
    price: 4,
    articles: [
        {
            product: products.product8,
            is_weight_quantity: false,
            quantity: 5,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-7)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive9,
            changes: [
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [
                {
                    product: products.product8,
                    is_weight_quantity: false,
                    quantity: 5,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-7)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-7)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order417: Order = {
    id: 417,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0688990011',
    site: sites.site16,
    price: 4,
    articles: [
        {
            product: products.product9,
            is_weight_quantity: false,
            quantity: 4,
        },
        {
            product: products.product10,
            is_weight_quantity: false,
            quantity: 3,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-6)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0688990011',
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager9,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-6)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager9,
            changes: [
                {
                    product: products.product9,
                    is_weight_quantity: false,
                    quantity: 4,
                },
                {
                    product: products.product10,
                    is_weight_quantity: false,
                    quantity: 3,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-6)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager9,
            changes: [],
        },
    ],
}

export const order418: Order = {
    id: 418,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive10,
    site: sites.site17,
    price: 4,
    articles: [
        {
            product: products.product11,
            is_weight_quantity: true,
            quantity: 650,
        },
        {
            product: products.product12,
            is_weight_quantity: false,
            quantity: 27,
        },
        {
            product: products.product13,
            is_weight_quantity: false,
            quantity: 1,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-5)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive10,
            changes: [
                {
                    product: products.product11,
                    is_weight_quantity: true,
                    quantity: 650,
                },
                {
                    product: products.product12,
                    is_weight_quantity: false,
                    quantity: 27,
                },
                {
                    product: products.product13,
                    is_weight_quantity: false,
                    quantity: 1,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-5)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order419: Order = {
    id: 419,
    status: StatusOrder.enum.RETRIEVED,
    phone_number: '0699001122',
    site: sites.site18,
    price: 4,
    articles: [
        {
            product: products.product14,
            is_weight_quantity: false,
            quantity: 4,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-4)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: '0699001122',
            changes: [
                {
                    product: products.product1,
                    is_weight_quantity: true,
                    quantity: 100,
                },
                {
                    product: products.product2,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product3,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product4,
                    is_weight_quantity: false,
                    quantity: 6,
                },
                {
                    product: products.product5,
                    is_weight_quantity: true,
                    quantity: 1_500,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager10,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-4)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager10,
            changes: [
                {
                    product: products.product14,
                    is_weight_quantity: false,
                    quantity: 4,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-4)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager10,
            changes: [],
        },
    ],
}

export const order420: Order = {
    id: 420,
    status: StatusOrder.enum.RETRIEVED,
    konvive: konvives.konvive1,
    site: sites.site19,
    price: 4,
    articles: [
        {
            product: products.product15,
            is_weight_quantity: false,
            quantity: 5,
        },
        {
            product: products.product16,
            is_weight_quantity: false,
            quantity: 2,
        },
    ],
    history: [
        {
            datetime: `${newDateFormatted(-3)}T09:00:00`,
            status: StatusOrder.enum.IN_PREPARATION,
            author: konvives.konvive1,
            changes: [
                {
                    product: products.product15,
                    is_weight_quantity: false,
                    quantity: 5,
                },
                {
                    product: products.product16,
                    is_weight_quantity: false,
                    quantity: 2,
                },
            ],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.ON_DELIVERY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T10:00:00`,
            status: StatusOrder.enum.READY,
            author: managers.manager8,
            changes: [],
        },
        {
            datetime: `${newDateFormatted(-3)}T11:00:00`,
            status: StatusOrder.enum.RETRIEVED,
            author: managers.manager8,
            changes: [],
        },
    ],
}
